var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:{ allowZoom: _vm.allowZoom },attrs:{"src":_vm.computedUri,"alt":_vm.alt},on:{"click":_vm.openGLightBox}})}
var staticRenderFns = []

export { render, staticRenderFns }